// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt';
/* eslint-disable */
const { jwt } = useJwt({});

export default jwt;
